<template>
  <ul v-if="items">
    <template v-for="(item, i) of items">
      <li
        v-if="visible(item) && !item.separator"
        :key="i"
        :class="[
          {
            'active-menuitem': activeIndex === i && !item.to && !item.disabled,
          },
        ]"
        role="none"
      >
        <div v-if="item.items && root === true" class="arrow" />
        <router-link
          v-if="item.to"
          v-ripple
          :to="item.to"
          :class="[
            item.class,
            'p-ripple',
            { 'active-route': activeIndex === i, 'p-disabled': item.disabled },
          ]"
          :style="item.style"
          :target="item.target"
          exact
          role="menuitem"
          @click="onMenuItemClick($event, item, i)"
        >
          <i :class="item.icon" />
          <span>{{ item.label }}</span>
          <i
            v-if="item.items"
            class="pi pi-fw pi-angle-down menuitem-toggle-icon"
          />
          <span v-if="item.badge" class="menuitem-badge">{{ item.badge }}</span>
        </router-link>
        <a
          v-if="!item.to"
          v-ripple
          :href="item.url || '#'"
          :style="item.style"
          :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
          :target="item.target"
          role="menuitem"
          @click="onMenuItemClick($event, item, i)"
        >
          <i :class="item.icon" />
          <span>{{ item.label }}</span>
          <i
            v-if="item.items"
            class="pi pi-fw pi-angle-down menuitem-toggle-icon"
          />
          <span v-if="item.badge" class="menuitem-badge">{{ item.badge }}</span>
        </a>
        <transition name="layout-submenu-wrapper">
          <the-panel-submenu
            v-show="activeIndex === i"
            :items="visible(item) && item.items"
            @menuitem-click="$emit('menuitem-click', $event)"
          />
        </transition>
      </li>
      <li
        v-if="visible(item) && item.separator"
        :key="'separator' + i"
        class="p-menu-separator"
        :style="item.style"
        role="separator"
      />
    </template>
  </ul>
</template>
<script>
import { ref } from "@vue/reactivity";

export default {
  name: "ThePanelSubmenu",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    root: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["menuitem-click"],
  setup() {
    const activeIndex = ref(null);

    function visible(item) {
      return typeof item.visible === "function"
        ? item.visible()
        : item.visible !== false;
    }

    return {
      activeIndex,
      visible,
    };
  },
  methods: {
    onMenuItemClick(event, item, index) {
      if (item.disabled) {
        event.preventDefault();
        return;
      }

      if (!item.to && !item.url) {
        event.preventDefault();
      }

      //execute command
      if (item.command) {
        item.command({ originalEvent: event, item: item });
      }

      this.activeIndex = index === this.activeIndex ? null : index;

      this.$emit("menuitem-click", {
        originalEvent: event,
        item: item,
      });
    },
  },
};
</script>

<style scoped></style>
